<script>
/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  defineComponent,
  reactive,
  h,
  watchEffect,
  toRefs,
  watch,
  ref,
} from "@vue/composition-api";
import moment from "moment";
import { CheckRecordServiceProxy } from "@/service-proxies/app-v2/tpm.service-proxies";
import { downloadGET, exportCheckItem } from "@/api/api";
import { readAsDataURL, downloadFile as download } from "@/utils";
import useTable from "@/hooks/useTable";
import useModal from "@/hooks/useModal";
import previewImg from "@/components/PreviewImg/index.vue";
import { getImg, getTxt } from "@/utils";
import { cloneDeep } from "lodash";
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'
const resourceService = new ResourceServiceProxy()

const crsp = new CheckRecordServiceProxy();

export default defineComponent({
  props: ["deviceId"],
  components: {
    previewImg,
  },
  setup(props, { root }) {
    const { deviceId } = toRefs(props);
    const previewVisible = ref(false);
    const previewIndex = ref();
    const imgList = ref([]);
    const fileSrcs = ref([]);
    const encode = ref("UTF-8");

    const fileFormData = reactive({
      fileList: [],
      remark: "",
      srcs: [],
      galleryVisible: false,
      currentIndex: 0,
    });
    const {
      tableAttrs: recordTableAttrs,
      currentRecord,
      read: getRecordTableData,
      isDeletable,
    } = useTable(
      {
        class: "m-2",
        columns: [
          {
            title: "操作",
            customRender: (record) =>
              h(
                "a",
                {
                  on: {
                    click() {
                      getRecordFiles(record.id);
                      fileFormData.remark = record.remark;
                      fileModalAttrs.visible = true;
                    },
                  },
                },
                "查看附件"
              ),
            i18n: "actions",
          },
          {
            title: "点检单号",
            dataIndex: "checkCode",
            i18n: "page_tpm_check_record_code",
          },
          {
            title: "检验人员",
            dataIndex: "checkUserName",
            i18n: "page_tpm_check_record_person",
          },
          {
            title: "点检时间",
            dataIndex: "checkTime",
            customRender: (time) => moment(time).format("YYYY-MM-DD HH:mm:ss"),
            i18n: "page_tpm_check_record_time",
          },
          {
            title: "检验项目",
            dataIndex: "checkProjectName",
            i18n: "page_tpm_check_record_project",
          },
          {
            title: "检验结果",
            dataIndex: "checkResult",
            customRender: (result) =>
              result === 0
                ? root.$t("page_tpm_check_record_bad" || "异常")
                : root.$t("page_tpm_check_record_good" || "正常"),
            i18n: "page_tpm_check_record_result",
          },
        ],
      },
      {
        read: crsp.getPage.bind(crsp),
      },
      (record) => {
        itemTableAttrs.pagination.current = 1;
        getItemTableData(
          record.id,
          itemTableAttrs.pagination.current,
          itemTableAttrs.pagination.pageSize
        );
      },
      (page, pageSize) =>
        getRecordTableData(page, deviceId.value, "", pageSize),
      () => {
        if (itemTableAttrs) itemTableAttrs.dataSource = [];
      }
    );

    const { tableAttrs: itemTableAttrs, read: getItemTableData } = useTable(
      {
        columns: [
          {
            title: "点检项",
            dataIndex: "name",
            i18n: "page_tpm_check_item_name",
          },
          {
            title: "数值类型",
            dataIndex: "valueType",
            i18n: "page_tpm_check_item_type",
          },
          {
            title: "标准数值",
            dataIndex: "standardValue",
            i18n: "page_tpm_check_item_standard",
          },
          {
            title: "检验数值",
            dataIndex: "checkValue",
            i18n: "page_tpm_check_record_value",
          },
        ],
        rowSelection: null,
      },
      {
        read: crsp.checkRecordItemList.bind(crsp),
      },
      undefined,
      (page, pageSize) =>
        getItemTableData(currentRecord.value.id, page, pageSize)
    );

    const {
      modalAttrs: fileModalAttrs,
      modalEvents: fileModalEvents,
    } = useModal(
      {
        title: root.$t("page_tpm_check_watch_file" || "查看附件"),
        okButtonProps: { style: "display: none" },
      },
      {
        cancel() {
          fileModalAttrs.visible = false;
          // fileFormData.srcs = []
          fileSrcs.value = [];
        },
      }
    );

    function changeEncode(val) {
      encode.value = val;
      getCurrentFiles();
    }

    async function getRecordFiles(recordId) {
      fileFormData.fileList = await crsp.checkRecordFileList(recordId);
      getCurrentFiles();
    }

    const getCurrentFiles = () => {
      imgList.value = [];
      fileFormData.fileList.map(async (file, index) => {
        let content;

        if (
          file.contentType != "image/jpg" &&
          file.contentType != "image/jpeg" &&
          file.contentType != "image/png" &&
          file.contentType != "image/svg" &&
          file.contentType != "image/gif" &&
          file.contentType != "text/txt" &&
          file.contentType != "text/json" &&
          file.contentType != "application/pdf" &&
          file.contentType != "application/swf" &&
          file.contentType != "image/octet-stream"
        ) {
          file.contentType = "text/txt";
          content = await getTxt(file, encode.value);
        }

        if (file.contentType.indexOf("image") > -1) {
          content = await getImg(file);
        }

        if (file.contentType.indexOf("pdf") > -1) {
          content = await (
            await resourceService.statFileUsingGET(file.objectKey)
          ).data.link;
        }

        let temp = {
          type: file.contentType.substring(0, file.contentType.indexOf("/")),
          content,
        };
        fileSrcs.value[index] = temp;
        fileSrcs.value = cloneDeep(fileSrcs.value);
      });
    };

    async function downloadFile(file) {
      const res = await downloadGET(
        file.fileName,
        file.objectKey,
        file.contentType
      );
      fileFormData.src = await readAsDataURL(res);
    }

    async function handleExport() {
      const res = await exportCheckItem({
        ids: recordTableAttrs.dataSource
          .map((item) => item.id)
          .filter((id) =>
            recordTableAttrs.rowSelection.selectedRowKeys.includes(id)
          ),
      });
      download(res, root.$t("page_tpm_check_item_name") + ".xlsx");
    }
    function openPreview(i, arr) {
      this.previewVisible = true;
      this.previewIndex = i;
    }
    function closePreview() {
      this.previewVisible = false;
    }

    watch(
      deviceId,
      (id) => {
        getRecordTableData(
          recordTableAttrs.pagination.current,
          id,
          "",
          recordTableAttrs.pagination.pageSize
        );
      },
      { immediate: true }
    );

    return {
      recordTableAttrs,
      isDeletable,

      itemTableAttrs,

      fileModalAttrs,
      fileModalEvents,

      fileFormData,

      downloadFile,
      handleExport,

      currentRecord,
      openPreview,
      closePreview,
      previewVisible,
      previewIndex,
      imgList,
      fileSrcs,
      changeEncode,
      getCurrentFiles,
      encode,
    };
  },
});
</script>

<template>
  <div>
    <a-button class="m-2" :disabled="!isDeletable" @click="handleExport">{{
      $t("page_time_analysis_output") || "导出"
    }}</a-button>

    <ml-table v-bind="recordTableAttrs"></ml-table>

    <ml-table v-bind="itemTableAttrs"></ml-table>

    <a-modal v-bind="fileModalAttrs" v-on="fileModalEvents">
      <a-form :labelCol="{ span: 5 }" :wrapperCol="{ span: 12 }">
        <a-form-item :label="$t('page_tpm_check_record_file') || '点检附件'">
          <ul>
            <li v-for="(item, index) in fileSrcs" :key="index">
              <!-- <div class="d-flex" style="justify-content: center; align-items: center; width: 150px; height: 150px;">
                <img
                  :src="fileFormData.srcs[index]"
                  style="max-width: 100%; max-height: 100%; cursor: pointer"
                  @click="
                    () => {
                      fileFormData.currentIndex = index
                      fileFormData.galleryVisible = true
                    }
                  "
                />
              </div> -->
              <div class="img-panel">
                <img
                  v-if="item && item.type && item.type === 'image'"
                  :src="item.content"
                  @click="openPreview(index)"
                  style="cursor: pointer"
                />
                <div
                  @click="openPreview(index)"
                  style="position: absolute;z-index: 9999; width:192px; height: 178px;cursor: pointer"
                ></div>
                <embed
                  v-if="item && item.type && item.type === 'application'"
                  :src="item.content"
                  type="application/pdf"
                  style="cursor: pointer"
                />
                <div
                  v-if="item && item.type && item.type === 'text'"
                  @click="openPreview(index)"
                >
                  <textarea
                    class="txt-content"
                    :placeholder="$t('common_please_input') + $t('page_tpm_check_record_remark') || '详细情况描述'"
                    v-model="item.content"
                    style="cursor: pointer; color:#000000;"
                    disabled
                  />
                </div>
              </div>
            </li>
          </ul>
        </a-form-item>
        <a-form-item
          :label="$t('page_tpm_check_record_remark') || '详细情况描述'"
        >
          <a-textarea :value="fileFormData.remark" :placeholder="$t('common_please_input') + $t('page_tpm_check_record_remark') || '详细情况描述'" disabled />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- <gallery
      :imgs="fileFormData.srcs"
      :visible="fileFormData.galleryVisible"
      :index="fileFormData.currentIndex"
      @cancel="() => (fileFormData.galleryVisible = false)"
    ></gallery> -->
    <previewImg
      :visible="previewVisible"
      :imgs="fileSrcs"
      :index="previewIndex"
      @cancel="closePreview"
      @changeEncode="changeEncode"
    />
  </div>
</template>
<style lang="less" scoped>
.img-panel {
  margin-bottom: 10px;
  background-color: #fafafa;
  color: #00000025;
  border: 1px solid #00000025;
  width: 192px;
  height: 178px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
img {
  width: 100%;
  height: 100%;
}
</style>
